import * as marketplaceReviewsRepositoryModule from '@/repositories/marketplace-reviews.repository';
import * as marketplaceProductsRepositoryModule from '@/repositories/marketplace-products.repository';
import * as marketplaceBrandsRepositoryModule from '@/repositories/marketplace-brands.repository';
import * as clientSettingsRepositoryModule from '@/repositories/client-settings.repository';
import * as clientAiProfileRepositoryModule from '@/repositories/client-ai-profile.repository';
import * as clientProfileRepositoryModule from '@/repositories/client-profile.repository';
import * as clientFeatureControlsRepositoryModule from '@/repositories/client-feature-controls.repository';
import * as clientBillingRepositoryModule from '@/repositories/client-billing.repository';
import * as clientOnboardingRepositoryModule from '@/repositories/client-onboarding.repository';
import * as maxNotificationsRepositoryModule from '@/repositories/max-notifications.repository';

export type MarketplaceApiPorts = {
    reviewsApi: ReturnType<typeof marketplaceReviewsRepositoryModule.createMarketplaceReviewsRepository>;
    productsApi: ReturnType<typeof marketplaceProductsRepositoryModule.createMarketplaceProductsRepository>;
    brandsApi: ReturnType<typeof marketplaceBrandsRepositoryModule.createMarketplaceBrandsRepository>;
    settingsApi: ReturnType<typeof clientSettingsRepositoryModule.createClientSettingsRepository>;
    aiProfileApi: ReturnType<typeof clientAiProfileRepositoryModule.createClientAiProfileRepository>;
    clientProfileApi: ReturnType<typeof clientProfileRepositoryModule.createClientProfileRepository>;
    featureControlsApi: ReturnType<typeof clientFeatureControlsRepositoryModule.createClientFeatureControlsRepository>;
    billingApi: ReturnType<typeof clientBillingRepositoryModule.createClientBillingRepository>;
    onboardingApi: ReturnType<typeof clientOnboardingRepositoryModule.createClientOnboardingRepository>;
    maxNotificationsApi: ReturnType<typeof maxNotificationsRepositoryModule.createMaxNotificationsRepository>;
};

const createReviewsApi = (): MarketplaceApiPorts['reviewsApi'] =>
    marketplaceReviewsRepositoryModule.createMarketplaceReviewsRepository();

const createProductsApi = (): MarketplaceApiPorts['productsApi'] =>
    marketplaceProductsRepositoryModule.createMarketplaceProductsRepository();

const createBrandsApi = (): MarketplaceApiPorts['brandsApi'] =>
    marketplaceBrandsRepositoryModule.createMarketplaceBrandsRepository();

const createSettingsApi = (): MarketplaceApiPorts['settingsApi'] =>
    clientSettingsRepositoryModule.createClientSettingsRepository();

const createAiProfileApi = (): MarketplaceApiPorts['aiProfileApi'] =>
    clientAiProfileRepositoryModule.createClientAiProfileRepository();

const createClientProfileApi = (): MarketplaceApiPorts['clientProfileApi'] =>
    clientProfileRepositoryModule.createClientProfileRepository();

const createFeatureControlsApi = (): MarketplaceApiPorts['featureControlsApi'] =>
    clientFeatureControlsRepositoryModule.createClientFeatureControlsRepository();

const createBillingApi = (): MarketplaceApiPorts['billingApi'] =>
    clientBillingRepositoryModule.createClientBillingRepository();

const createOnboardingApi = (): MarketplaceApiPorts['onboardingApi'] =>
    clientOnboardingRepositoryModule.createClientOnboardingRepository();

const createMaxNotificationsApi = (): MarketplaceApiPorts['maxNotificationsApi'] =>
    maxNotificationsRepositoryModule.createMaxNotificationsRepository();

export const createMarketplaceApiPorts = (): MarketplaceApiPorts => ({
    reviewsApi: createReviewsApi(),
    productsApi: createProductsApi(),
    brandsApi: createBrandsApi(),
    settingsApi: createSettingsApi(),
    aiProfileApi: createAiProfileApi(),
    clientProfileApi: createClientProfileApi(),
    featureControlsApi: createFeatureControlsApi(),
    billingApi: createBillingApi(),
    onboardingApi: createOnboardingApi(),
    maxNotificationsApi: createMaxNotificationsApi(),
});
